import { Alert, AlertProps, TextField } from "@mui/material";

export const CreatePinInput = ({
  pin,
  confirmPin,
  onPinChange,
  onConfirmPinChange,
  alert,
  onKeyDown,
  disabled,
}: {
  pin: string;
  confirmPin: string;
  onPinChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onConfirmPinChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  disabled?: boolean;
  alert?: {
    severity?: AlertProps["severity"];
    alertContent?: React.ReactNode;
  } | null;
}) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-3">
        <div className="flex flex-col gap-2 flex-1">
          <TextField
            label="PIN"
            type="password"
            inputMode="numeric"
            value={pin}
            onChange={onPinChange}
            onKeyDown={onKeyDown}
            disabled={disabled}
            inputProps={{
              maxLength: 4,
              pattern: "[0-9]*",
            }}
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                borderBottomStyle: "none",
              },
              "& .Mui-disabled:before": {
                borderBottomStyle: "none !important",
              },
              "&.MuiInputBase-root-MuiFilledInput-root.Mui-disabled:before": {
                borderBottomStyle: "none",
              },
            }}
            placeholder="0000"
            autoFocus
          />
        </div>
        <div className="flex flex-col gap-2 flex-1">
          <TextField
            type="password"
            inputMode="numeric"
            label="Confirm PIN"
            value={confirmPin}
            onChange={onConfirmPinChange}
            onKeyDown={onKeyDown}
            error={alert?.severity === "error"}
            disabled={disabled}
            inputProps={{
              maxLength: 4,
              pattern: "[0-9]*",
            }}
            sx={{
              "& .Mui-disabled:before": {
                borderBottomStyle: "none",
              },
            }}
            placeholder="0000"
          />
        </div>
      </div>
      {alert?.severity && (
        <Alert
          severity={alert?.severity || "error"}
          sx={{ fontSize: "0.875rem", marginTop: "10px", maxWidth: "100%" }}
        >
          {alert?.alertContent}
        </Alert>
      )}
    </div>
  );
};

export default CreatePinInput;
